import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import SmartPrepackCpmponentComponent from 'components/Sales/Smart/Prepack/PickForPack';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function PickForPack(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="titles.pickForPack" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    // title={`Prepack: Pick For Pack(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
    >
      <SmartPrepackCpmponentComponent />
    </ContentLayout>
  );
}
